import LensBlurIcon from '@mui/icons-material/LensBlur';
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

/**
 * A status indicator that displays the status text and an icon for each status.
 *
 * This currently supports the following statuses:
 *
 * - "analyzing"
 * - "failed"
 * - "succeeded"
 */
export default function StatusIcon(props) {
  const { status } = props;

  let icon;
  let color;
  if (status === "analyzing") {
    icon = (<LensBlurIcon height="20px" sx={{marginBottom: "-7px"}} />);
    color = '#ed6c02';
  } else if (status === "failed") {
    icon = (<ErrorIcon height="20px" sx={{marginBottom: "-6px"}} />);
    color = '#ed6c02';
  } else if (status === "succeeded") {
    icon = (<CheckCircleIcon height="20px" sx={{marginBottom: "-7px"}} />);
    color = "green";
  }

  const text = String(status).charAt(0).toUpperCase() + String(status).slice(1);

  return (
    <p>
      <span style={{ color: 'gray' }}>
        <b>Clonality Detection Status: </b>
      </span>
      <span style={{ color: color }}>
        <b>{text} </b>
        {icon}
      </span>
    </p>
  )
}
